import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("直播间管理");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("预约记录");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_4 = {
  style: {
    "margin-left": "12px",
    "color": "#666"
  }
};
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getLiveSubscribeList } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'LiveSubscribeList',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const table = ref();
    const liveId = computed(() => route.query.liveId);
    const pageTitle = computed(() => route.query.title || `直播ID: ${liveId.value || '-'}`);
    const tableOptions = getVexTableProps({
      columns: [{
        field: 'id',
        title: '记录ID',
        width: '100px'
      }, {
        field: 'supAccountId',
        title: '用户账号ID',
        minWidth: '160px'
      }, {
        field: 'status',
        title: '状态',
        width: '100px',

        formatter({
          cellValue
        }) {
          return cellValue === 1 ? '已预约' : '已取消';
        }

      }, {
        field: 'createAt',
        title: '预约时间',
        width: '180px'
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '180px'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            if (!liveId.value) {
              res({
                total: 0,
                result: []
              });
              return;
            }

            getLiveSubscribeList({
              liveId: liveId.value,
              page: page.currentPage,
              pageSize: page.pageSize
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        },
        align: "middle"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(pageTitle)), 1)]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions), {
        style: {
          "margin-top": "16px"
        }
      }), null, 16)]);
    };
  }

};